export function localLog(text: string) {
  if (window.location.host.match(/^localhost/)) {
    console.log(text)
  }
}
